import { useRef } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import {
  COMPANY,
  HOSTING,
  SITE_URL,
  formatAddress,
  telHref,
} from "../../config/company";
import GoToTop from "../../contexts/gototop";
import CompanyContact from "../companycontact/CompanyContact";
import FloatingChatButton from "../floatingchat/FloatingChat";
import "../solar/solar-model.scss";

const Row = ({ label, children }) => (
  <p>
    <strong>{label}:</strong> {children}
  </p>
);

const ImpresszumModel = () => {
  const chatButton = useRef();

  return (
    <>
      <Helmet>
        <title>{`Impresszum | ${COMPANY.shortName}`}</title>
        <meta
          name="description"
          content={`${COMPANY.shortName} – impresszum, cégadatok és elérhetőségek. Székhely: ${formatAddress()}.`}
        />
        <link rel="canonical" href={`${SITE_URL}/impresszum`} />
      </Helmet>
      <div className="solar">
        <div className="solar__section">
          <div
            className="solar__section__cover"
            id="top"
            style={{
              backgroundImage: `url(${require(`../../assets/solar/oktatoshatter.jpg`)})`,
            }}></div>
          <div className="solar__section__specs">
            <div className="solar__section__specs__div">
              <div style={{ lineHeight: 1.8 }}>
                <h3 style={{ textAlign: "center", marginBottom: "2rem" }}>
                  Impresszum
                </h3>

                <h4>Üzemeltető / szolgáltató</h4>
                <Row label="Cégnév">{COMPANY.fullName}</Row>
                <Row label="Rövidített cégnév">{COMPANY.shortName}</Row>
                <Row label="Székhely">{formatAddress(true)}</Row>
                <Row label="Cégjegyzékszám">{COMPANY.registrationNumber}</Row>
                <Row label="Nyilvántartó cégbíróság">
                  {COMPANY.registryCourt}
                </Row>
                <Row label="Adószám">{COMPANY.taxNumber}</Row>
                <Row label="Közösségi adószám">{COMPANY.euVatNumber}</Row>
                <Row label="Főtevékenység">{COMPANY.mainActivity}</Row>
                <Row label="E-mail">
                  {COMPANY.emails.map((email, i) => (
                    <span key={email}>
                      {i > 0 && ", "}
                      <a href={`mailto:${email}`}>{email}</a>
                    </span>
                  ))}
                </Row>
                <Row label="Telefon">
                  {COMPANY.phones.map((phone, i) => (
                    <span key={phone}>
                      {i > 0 && ", "}
                      <a href={telHref(phone)}>{phone}</a>
                    </span>
                  ))}
                </Row>
                <Row label="Weboldal">
                  <a href={SITE_URL}>{SITE_URL.replace("https://", "")}</a>
                </Row>

                <h4 style={{ marginTop: "2rem" }}>Tárhelyszolgáltató</h4>
                <Row label="Név">{HOSTING.name}</Row>
                <Row label="Cím">{HOSTING.address}</Row>
                <Row label="E-mail">
                  <a href={`mailto:${HOSTING.email}`}>{HOSTING.email}</a>
                </Row>
                <Row label="Weboldal">
                  <a href={HOSTING.web} target="_blank" rel="noreferrer">
                    {HOSTING.web.replace("https://", "")}
                  </a>
                </Row>

                <h4 style={{ marginTop: "2rem" }}>Jogi dokumentumok</h4>
                <p>
                  <Link to="/aszf">Általános szerződési feltételek</Link>
                  {" · "}
                  <Link to="/adatkezelesi-tajekoztato">
                    Adatkezelési tájékoztató
                  </Link>
                </p>

                <p style={{ marginTop: "2rem", fontSize: "0.85rem" }}>
                  A weboldalon megjelenő tartalmak (szövegek, képek, logók)
                  szerzői jogi védelem alatt állnak, azok a{" "}
                  {COMPANY.shortName} előzetes írásos engedélye nélkül nem
                  másolhatók és nem terjeszthetők.
                </p>
              </div>
            </div>
          </div>
        </div>

        <CompanyContact
          buttonClassName="btn-primary"
          onCallback={() => chatButton.current.openChat()}
        />
      </div>
      <GoToTop />
      <FloatingChatButton ref={chatButton} />
    </>
  );
};

export default ImpresszumModel;
